import React from 'react';
import classNames from 'classnames';

import Currency from 'components/Currency';

import './ProductItemPrice.scss';

type ProductItemPriceProps = {
	product: LP.product.ProductItem,
	highlightSalePrice?: boolean,
	showSaleCallout?: boolean,
	showSavePrice?: boolean,
	showJustForYouSaleCallout?: boolean,
	priceText?: string
}
function ProductItemPrice ({
	product, highlightSalePrice = false, showSaleCallout = false, showSavePrice = false, showJustForYouSaleCallout = false, priceText
}: ProductItemPriceProps) {

	const className = classNames('ProductItemPrice', {
		'ProductItemPrice--salePrice': highlightSalePrice && product.IsOnSale,
		'ProductItemPrice--hasPriceText': priceText
	});

	const isProductsOnSale = (product.IsOnSale && showJustForYouSaleCallout);

	if (product.IsNonNumericSku) {

		return null;

	}

	return (
		<div className={`${className} ${isProductsOnSale ? 'ProductItemSalePrice' : ''}`}>
			<Currency price={product.DisplayPrice} superscriptCents />
			{isProductsOnSale ? (<span>Sale</span>) : showSaleCallout && ' Sale'}
			{product.IsOnSale && product.SavePrice && showSavePrice && (
				<span className="ProductItemPrice__save">
					Save
					{' '}
					<Currency price={product.SavePrice} superscriptCents />
				</span>
			)}
			{priceText && (
				<span className="ProductItemPrice__callout">
					{priceText}
				</span>
			)}
		</div>
	);

}

export default ProductItemPrice;
